import LoginPage from '@/components/Login/LoginPage.vue';

export default [
    {
        path: '/verify',
        component: LoginPage,
        meta: { layout: 'default', title: 'Xác thực tài khoản'},
        name: 'verifyaccount',
    },
];
